export default __webpack_public_path__ + "static/media/close.efe4b15c.svg";